export class InsuranceDataModel {
    ReqDate: string;
    RecordName: string;
    DoctorName: string;
    Status: string;
    Amount: DoubleRange;
    ApprovedAmount: DoubleRange;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/insurance/insurancedatamodel.ts